module.exports = __webpack_public_path__ + "static/media/cloudy-day-1.1191a395.svg";